import * as React from 'react';
import { Icon, IconProps } from '../icon/icon';

export const IconWallet: React.FC<IconProps> = (props) => (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M21.75 18V21.5C21.75 21.8978 21.592 22.2794 21.3107 22.5607C21.0294 22.842 20.6478 23 20.25 23H3C2.40326 23 1.83097 22.7629 1.40901 22.341C0.987053 21.919 0.75 21.3467 0.75 20.75V3.25C0.75 2.65326 0.987053 2.08097 1.40901 1.65901C1.83097 1.23705 2.40326 1 3 1H18.75C19.1478 1 19.5294 1.15804 19.8107 1.43934C20.092 1.72064 20.25 2.10218 20.25 2.5V5.75"
        />
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M21.75 18C22.1478 18 22.5294 17.842 22.8107 17.5607C23.092 17.2794 23.25 16.8978 23.25 16.5V12C23.25 11.6022 23.092 11.2206 22.8107 10.9393C22.5294 10.658 22.1478 10.5 21.75 10.5H17.5C16.5054 10.5 15.5516 10.8951 14.8483 11.5983C14.1451 12.3016 13.75 13.2554 13.75 14.25C13.75 15.2446 14.1451 16.1984 14.8483 16.9017C15.5516 17.6049 16.5054 18 17.5 18H21.75Z"
        />
        <path
            stroke="currentColor"
            strokeWidth="1.5"
            d="M17.9951 14.6201C17.788 14.6201 17.6201 14.4523 17.6201 14.2451C17.6201 14.038 17.788 13.8701 17.9951 13.8701"
        />
        <path
            stroke="currentColor"
            strokeWidth="1.5"
            d="M17.9951 14.6201C18.2022 14.6201 18.3701 14.4523 18.3701 14.2451C18.3701 14.038 18.2022 13.8701 17.9951 13.8701"
        />
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M21.75 10.5V7.25001C21.75 6.85218 21.592 6.47065 21.3107 6.18935C21.0294 5.90804 20.6478 5.75001 20.25 5.75001H5.63C5.30133 5.76741 4.97437 5.6923 4.68624 5.53321C4.39811 5.37412 4.16036 5.13743 4 4.85001"
        />
    </Icon>
);
